import { render, staticRenderFns } from "./MineEmployee.vue?vue&type=template&id=2042b704&"
import script from "./MineEmployee.vue?vue&type=script&lang=js&"
export * from "./MineEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports